import { Link, useNavigate } from "react-router-dom";
import { RegisterPage } from "../components/MFA/Register";
import { useEffect } from "react";
import { useAtomValue } from "jotai";
import { userAtom } from "../atoms";
import { MFAContainer } from "../components/MFA/utils";
import { ValidatePage } from "../components/MFA/Validate";
import { Spinner } from "../components/Loader";

const UserError = (): JSX.Element => (
  <MFAContainer>
    <div>This user does not require MFA</div>
  </MFAContainer>
);

const MFAAuth = () => {
  const user = useAtomValue(userAtom);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) navigate("/auth");
    else if (user?.mfa_enabled === false) navigate("/");
  }, []);

  const Validate = () => <ValidatePage username={user?.username || ""} />;

  const ShowComponent =
    user?.mfa_enabled === false
      ? UserError
      : user?.mfa_verified
      ? Validate
      : user?.mfa_enabled
      ? RegisterPage
      : Spinner;

  return (
    <div
      className="w-full h-full grid place-content-center bg-cover gap-3"
      style={{ backgroundImage: "url(/assets/CMS_background.jpg)" }}
    >
      <ShowComponent />
      <div className="flex flex-col gap-2 py-3 text-center text-[#888888]">
        {user?.mfa_enabled && user.mfa_verified && (
          <Link
            to={"/request_mfa_reset"}
            className="transition opacity-80 hover:opacity-100 font-bold text-sm"
          >
            Reset token
          </Link>
        )}
        <Link
          to={"/logout"}
          className="transition opacity-80 hover:opacity-100 font-bold text-sm"
        >
          Logout
        </Link>
      </div>
    </div>
  );
};

export { MFAAuth };
